import React, { useState } from 'react'
import { Typography, Grid, Chip, Button } from '@mui/material'
import { useTranslate } from 'react-admin'
import { ColorDisplay } from 'src/components/uiElements/fields/DisplayColor'
import { DisplayJson } from 'src/components/uiElements/fields/DisplayJson'
import { ImageField, RecordContextProvider } from 'react-admin'
import HTMLInput from '../fields/HTMLInput'
import DisplayHTML from '../fields/DisplayHTML'
import { Code } from '@mui/icons-material'
const INCLUDE_OPTION = 'include'
const EXCLUDE_OPTION = 'exclude'

const ContextImage = ({ data }) => {
  return (
    <RecordContextProvider value={data}>
      <ImageField source='src' title='title' />
    </RecordContextProvider>
  )
}

export const ShowListElement = ({ type, value, label, sm, includeTime, ...props }) => {
  const translate = useTranslate()
  const [openHTMLModal, setOpenHTMLModal] = useState(false)
  const gridSm = sm ? sm : 4

  const formatDate = (date) => {
    if (date) {
      const dateAux = new Date(date)
      const year = dateAux.getFullYear()
      let month = (1 + dateAux.getMonth()).toString()
      month = month.length > 1 ? month : '0' + month
      let day = dateAux.getDate().toString()
      day = day.length > 1 ? day : '0' + day
      let hours = dateAux.getHours().toString()
      hours = hours.length > 1 ? hours : '0' + hours
      let minutes = dateAux.getMinutes().toString()
      minutes = minutes.length > 1 ? minutes : '0' + minutes
      let seconds = dateAux.getSeconds().toString()
      seconds = seconds.length > 1 ? seconds : '0' + seconds

      let text = `${day}/${month}/${year}`
      if (includeTime) {
        text += ` ${hours}:${minutes}:${seconds}`
      }

      return text
    }

    return null
  }

  const getText = (item, optionText) => optionText.map((option) => item[option]).join(' - ')

  const transformSelectValue = (data, values, optionText, optionValue = 'id') =>
    values
      .map((valueAux) => {
        const dataAux = data.find((elem) => elem[optionValue] === valueAux)
        return dataAux ? getText(dataAux, optionText) : null
      })
      .filter((elem) => elem)
      .join(', ')

  const getSelectValues = (value) => {
    if (!props.data || !value || value?.length === 0) return null

    let valueAux = [value]
    let text = ''
    if (props.multiple) {
      if (props.showAllOption) {
        const option = value[INCLUDE_OPTION] !== null ? 'include' : 'exclude'
        valueAux = value[INCLUDE_OPTION] || value[EXCLUDE_OPTION]
        text = `${translate(`ra.field.${option}`)}: `
        if (valueAux.length > 0 && valueAux[0] === 'all') {
          return 'Todos'
        }
      } else {
        valueAux = value
      }
    }

    return text + transformSelectValue(props.data, valueAux, props.optionText, props.optionValue)
  }

  const getValue = () => {
    if (value !== undefined || value !== null) {
      if (type === 'boolean') {
        return value ? translate('ra.message.yes') : translate('ra.message.no')
      } else if (type === 'date') {
        return formatDate(value)
      } else if (type === 'select') {
        return getSelectValues(value)
      } else if (type === 'chip') {
        return (
          value?.['include'] ||
          value?.['exclude'] ||
          value?.map((item) => <Chip size='small' key={item} label={item} variant='outlined' />)
        )
      } else if (type === 'array') {
        return value?.map((item, index) => (
          <Chip size='small' key={index} label={item[props.optionValue]} variant='outlined' />
        ))
      } else if (type === 'color') {
        return <ColorDisplay color={value} />
      } else if (type === 'image') {
        return <ContextImage data={value} />
      } else if (type === 'json') {
        return <DisplayJson value={value} />
      } else if (type === 'html') {
        return <>
          <Button
            variant='contained'
            startIcon={<Code />}
            onClick={() => {
              setOpenHTMLModal(true)
            }}
          >
            {translate('ra.field.see_html')}
          </Button>
          <DisplayHTML open={openHTMLModal} handleClose={() => setOpenHTMLModal(false)} value={value} />
        </>
      } else {
        return value
      }
    }

    return null
  }

  return (
    <Grid item xs={12} sm={gridSm} className='uiShowListElement'>
      {label && (
        <Typography className='keyText' component='div' color='text.primary'>
          {label}:{' '}
        </Typography>
      )}

      <Typography
        className='valueText'
        component='div'
        color='text.primary'
        style={{ overflowWrap: 'break-word' }}
      >
        {props?.loading ? 'Loading...' : getValue()}
      </Typography>
    </Grid>
  )
}
